import { Inject, Injectable } from '@angular/core';
import { UserGeoPointFacade } from '@city/data-access';
import { GeoHeaders, GeoPoint, SERVER_REQUEST } from '@core/const';
import { EnvironmentService } from '@core/feature';
import { WindowRef } from '@spartacus/core';
import { Request } from 'express';

@Injectable({
  providedIn: 'root',
})
export class UserGeoPointService {
  geoPoint$ = this.userGeoPointFacade.getGeoPoint();

  constructor(
    @Inject(SERVER_REQUEST) private request: Request<{ [key: string]: string }>,
    private winRef: WindowRef,
    private environmentService: EnvironmentService,
    private userGeoPointFacade: UserGeoPointFacade,
  ) {}

  obtainGeoPointServer(): void {
    if (this.environmentService.isPlatformServer) {
      const lat = this.request.headers[GeoHeaders.Latitude];
      const long = this.request.headers[GeoHeaders.Longitude];

      if (lat && long) {
        this.setGeoPoint({
          latitude: +lat,
          longitude: +long,
        });
      }
    }
  }

  obtainGeoPointBrowser(): void {
    if (this.environmentService.isPlatformBrowser) {
      const window = this.winRef.nativeWindow;
      window.navigator.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }: GeolocationPosition) => {
        this.setGeoPoint({
          latitude,
          longitude,
        });
      });
    }
  }

  setGeoPoint(geoPoint: GeoPoint): void {
    this.userGeoPointFacade.setGeoPoint(geoPoint);
  }
}
